import { Empty } from "antd";
import { useState } from "react";
import tiktokIcon from "../../../../images/tiktok-icon.svg";
import instagramIcon from "../../../../images/instagram-icon.svg";
import youtubeIcon from "../../../../images/youtube-icon.svg";
import { TiktokContents } from "./TiktokContents";
import { InstagramContents } from "./InstagramContents";
import { YoutubeContents } from "./YoutubeContents";

const social = [
  {
    key: "tiktok",
    label: "TikTok",
    icon: tiktokIcon,
  },
  {
    key: "instagram",
    label: "Instagram",
    icon: instagramIcon,
    iconClassName: "h-5 w-5 ml-[0.5px]",
  },
  {
    key: "youtube",
    label: "YouTube",
    icon: youtubeIcon,
  },
];

export const BrandSocialContents = ({ brandName, contents }) => {
  const [activeMenu, setActiveMenu] = useState("tiktok");

  if (brandName === "금바다") {
    return (
      <Empty
        description={
          <div className="text-[14px] text-[#666]">브랜드 영상이 없습니다.</div>
        }
      />
    );
  }

  return (
    <>
      <div className="flex flex-wrap items-center gap-3">
        {social.map((s) => (
          <button
            key={s.key}
            type="button"
            className={`flex h-10 w-10 items-center justify-center rounded-full border bg-white ${
              activeMenu === s.key ? "border-blue-500" : "border-[#ebeff5]"
            }`}
            onClick={() => setActiveMenu(s.key)}
            aria-label={s.label}
          >
            <img
              src={s.icon}
              alt=""
              className={`${s.iconClassName || "h-6 w-6"} object-contain`}
              aria-hidden
            />
          </button>
        ))}
      </div>
      <div>
        {activeMenu === "tiktok" && (
          <TiktokContents tiktok={contents?.tiktok} />
        )}
        {activeMenu === "instagram" && (
          <InstagramContents instagram={contents?.instagram} />
        )}
        {activeMenu === "youtube" && (
          <YoutubeContents youtube={contents?.youtube} />
        )}
      </div>
    </>
  );
};
